import React from 'react'
import { Stack } from '@mantine/core'
import { useTheme } from './ThemeProvider'

interface ItemWrapperProps {
  children: React.ReactNode
  className?: string
}

export default function ItemWrapper({ children, className }: ItemWrapperProps) {
  const theme = useTheme()

  return (
    <div
      className={`rounded-xl border px-5 py-5 shadow-sm print:shadow-none ${className || ''}`}
      style={{ backgroundColor: theme.surfaceColor, borderColor: theme.surfaceBorderColor }}
    >
      <Stack gap="md">{children}</Stack>
    </div>
  )
}
